import { r as rjPlugin, g as get } from '../../rjPlugin.es.js';
import { set } from 'object-path-immutable';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '@babel/runtime/helpers/esm/objectSpread2';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@babel/runtime/helpers/esm/toArray';
import 'rxjs';
import '@babel/runtime/helpers/esm/typeof';
import '@babel/runtime/helpers/esm/defineProperty';
import 'rxjs/operators';

var TYPE = 'RJ_LIST_INSERT';

var defaultMerge = function defaultMerge(action, list) {
  return (list || []).concat([action.item]);
};

var rjListInsert = function rjListInsert() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var path = config.path || 'data';
  return rjPlugin({
    actions: function actions() {
      return {
        insertItem: function insertItem(item) {
          return {
            type: TYPE,
            item: item
          };
        }
      };
    },
    reducer: function reducer(oldReducer) {
      return function (state, action) {
        if (action.type === TYPE) {
          if (process.env.NODE_ENV !== 'production') {
            if (config.warnPagination !== false) {
              var paginationPath = path.split('.').map(function (item, i, arr) {
                return i === arr.length - 1 ? 'pagination' : item;
              }).join('.');

              if (state && get(state, paginationPath)) {
                console.warn('It seems you are using this plugin on a paginated list. Remember that this plugin is agnostic wrt pagination, and will break it. To suppress this warning, set warnPagination: false in the config object');
              }
            }
          }

          var mergeFunc = config.merge ? config.merge : defaultMerge;
          return set(state, path, mergeFunc(action, get(state, path)));
        }

        return oldReducer(state, action);
      };
    }
  });
};

export default rjListInsert;
export { TYPE };
